const MODELS = [
  { id: "haiku", name: "Haiku", desc: "Rápido y económico", dot: "#059669" },
  { id: "sonnet", name: "Sonnet", desc: "Equilibrado (default)", dot: "#0066cc" },
  { id: "opus", name: "Opus", desc: "Máxima capacidad", dot: "#7c3aed" },
];

export function ModelPicker({ value, onChange, disabled }) {
  return (
    <div className="cop-model-picker">
      {MODELS.map((m) => (
        <button
          key={m.id}
          type="button"
          disabled={disabled}
          className={`cop-model-opt ${value === m.id ? "active" : ""}`}
          onClick={() => onChange(m.id)}
          title={m.desc}
        >
          <span className="cop-model-dot" style={{ background: m.dot }} />
          {m.name}
        </button>
      ))}
    </div>
  );
}
